var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-box",class:{ 'hide-on-desktop': _vm.hideOnDesktop }},[_vm._t("default"),_c('div',{staticClass:"tooltip-content",style:({ bottom: 24 + 'px' })},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }